export default __webpack_public_path__ + "resources/icons/d122-4439.png";